// Shared CSV export helper for mobile card lists (tables without an underlying BootstrapTable to export from).
// Each page supplies its own columnDefs (label + value getter, using its own t()/formatters) and raw data array;
// this helper only handles escaping, building rows, and triggering the download.

const escapeCSV = (value) => {
	const str = value === undefined || value === null ? '' : String(value);
	return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

// columnDefs: Array<{ header: string, value: (row) => any }>
// data: Array<row>
// filename: string (without extension)
export const downloadMobileCSV = (columnDefs, data, filename) => {
	const headerRow = columnDefs.map(c => escapeCSV(c.header)).join(',');
	const dataRows = data.map(row => columnDefs.map(c => escapeCSV(c.value(row))).join(','));
	const csvContent = [headerRow, ...dataRows].join('\n');

	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', `${filename}.csv`);
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
};
